import {
  Country,
  ObligationRulesGeneratorAllowedFields,
} from '@commenda/prisma';
import { ProfileFieldKey } from './fieldCatalog.types';

const {
  EMPLOYEE_COUNT,
  REVENUE_BAND,
  HAS_FOREIGN_SUBSIDIARY,
  TAX_CLASSIFICATION,
} = ObligationRulesGeneratorAllowedFields;

export const ALL_ALLOWED_FIELDS_BY_COUNTRY: Partial<
  Record<Country, ProfileFieldKey[]>
> = {
  [Country.US]: [EMPLOYEE_COUNT, HAS_FOREIGN_SUBSIDIARY, TAX_CLASSIFICATION],
  [Country.CA]: [REVENUE_BAND, HAS_FOREIGN_SUBSIDIARY],
  [Country.IN]: [EMPLOYEE_COUNT, REVENUE_BAND, HAS_FOREIGN_SUBSIDIARY],
  [Country.GB]: [EMPLOYEE_COUNT],
  [Country.SG]: [EMPLOYEE_COUNT, REVENUE_BAND, HAS_FOREIGN_SUBSIDIARY],
};

export const REQUIRED_ALLOWED_FIELDS_BY_COUNTRY: Partial<
  Record<Country, ProfileFieldKey[]>
> = {
  [Country.US]: [EMPLOYEE_COUNT, HAS_FOREIGN_SUBSIDIARY],
  [Country.CA]: [REVENUE_BAND, HAS_FOREIGN_SUBSIDIARY],
  [Country.IN]: [EMPLOYEE_COUNT, REVENUE_BAND, HAS_FOREIGN_SUBSIDIARY],
  [Country.GB]: [EMPLOYEE_COUNT],
  [Country.SG]: [EMPLOYEE_COUNT, REVENUE_BAND, HAS_FOREIGN_SUBSIDIARY],
};

export const DEFAULT_PROFILE_FIELDS: ProfileFieldKey[] = [
  EMPLOYEE_COUNT,
  REVENUE_BAND,
  HAS_FOREIGN_SUBSIDIARY,
];

export const DEFAULT_REQUIRED_ALLOWED_FIELDS: ProfileFieldKey[] = [
  EMPLOYEE_COUNT,
  REVENUE_BAND,
  HAS_FOREIGN_SUBSIDIARY,
];

export function getProfileFields(
  country: Country | undefined
): ProfileFieldKey[] {
  return (
    (country && ALL_ALLOWED_FIELDS_BY_COUNTRY[country]) ||
    DEFAULT_PROFILE_FIELDS
  );
}

export function getRequiredFields(
  country: Country | undefined
): readonly ProfileFieldKey[] {
  return (
    (country && REQUIRED_ALLOWED_FIELDS_BY_COUNTRY[country]) ||
    DEFAULT_REQUIRED_ALLOWED_FIELDS
  );
}
